import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
export const resetEditorPublishResults = createAction(`${actionTypePrefix}/RESET_EDITOR_PUBLISH_RESULTS`, (editorId)=>({
        editorId
    }));
export const publishComment = createAction(`${actionTypePrefix}/PUBLISH_COMMENT`, (publisher)=>publisher);
export const publishCommentSuccess = createAction(`${actionTypePrefix}/PUBLISH_COMMENT_SUCCESS`, (result)=>result);
export const publishCommentFailure = createAction(`${actionTypePrefix}/PUBLISH_COMMENT_FAILURE`, (result)=>result);
export const focusEditor = createAction(`${actionTypePrefix}/FOCUS_EDITOR`, (editorId)=>({
        editorId
    }));
export const focusEditorWithScroll = createAction(`${actionTypePrefix}/FOCUS_EDITOR_WITH_SCROLL`, (editorId, smoothScroll)=>({
        editorId,
        smoothScroll
    }));
export const focusDone = createAction(`${actionTypePrefix}/FOCUS_DONE`, (editorId)=>({
        editorId
    }));

//# sourceMappingURL=actionCreators.js.map